import React, { useMemo, useState } from 'react';
import { PcAvatar, PcSearch } from './PricingUi';

export const ClientList = ({ clients, summary, selected, onSelect, loading }) => {
  const [q, setQ] = useState('');
  const filtered = useMemo(() => { const s = q.trim().toLowerCase(); return s ? clients.filter((c) => `${c.code} ${c.name || ''}`.toLowerCase().includes(s)) : clients; }, [clients, q]);
  return (
    <aside className="pc-card pc-clients" data-testid="csp-client-list">
      <div className="pc-clients-head"><span data-testid="csp-client-count">Clients ({loading ? '…' : filtered.length})</span></div>
      <div className="pc-clients-search"><PcSearch placeholder="Search clients…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="csp-client-search" /></div>
      <div className="pc-clients-list">
        {loading && Array.from({ length: 8 }).map((_, i) => <div key={i} className="pc-client-item" style={{ pointerEvents: 'none' }}><span className="pc-skel-block" style={{ width: 30, height: 30, borderRadius: 10 }} /><span className="pc-skel-block" style={{ width: `${40 + (i * 17) % 40}%` }} /></div>)}
        {!loading && filtered.map((c) => (
          <button type="button" key={c.id} onClick={() => onSelect(c)} className={`pc-client-item ${selected?.id === c.id ? 'is-selected' : ''}`} data-testid={`csp-client-${c.code}`} title={c.name}>
            <PcAvatar label={c.code} />
            <div className="min-w-0 flex-1">
              <div className="pc-client-code">{c.code}</div>
              {c.name && c.name !== c.code && <div className="pc-client-name">{c.name}</div>}
            </div>
            {summary[c.id] ? <span className="pc-client-count" title={`${summary[c.id]} active prices`}>{summary[c.id]}</span> : null}
          </button>
        ))}
        {!loading && filtered.length === 0 && <div className="pc-clients-none" data-testid="csp-client-none">{clients.length ? 'No clients match your search.' : 'No active clients.'}</div>}
      </div>
    </aside>
  );
};
